import { __assign } from "tslib";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore commonsjs module
import { ApolloLink } from '@apollo/client';
// share configEnv.client through context chain
export var configLink = function (configEnv) {
    return new ApolloLink(function (operation, forward) {
        operation.setContext(function (prev) { return (__assign(__assign({}, prev), { configEnv: configEnv })); });
        return forward(operation);
    });
};
//# sourceMappingURL=configLink.js.map